import PersonalizationCardImage from "../components/PersonalizationCardImage";
import PersonalizationInput from "../components/PersonalizationInput";
import PersonalizationTextarea from "../components/PersonalizationTextarea";
import PersonalizationDivider from "../components/PersonalizationDivider";
import Dropdown from "../../../../Admin Panel/Dropdown/Dropdown";
import React from "react";

export default function WellnessHealthIntroScreen({getWellnessError, wellnessFormData,setWellnessFormData}) {
    const scaleDesignOptions = [
        {
            name:(
                <span style={{display:"inline-flex", alignItems:"center", gap:"4px"}}>
                    <img src={"/assets/ic_like.svg"} alt={"Best"} style={{width:"12px", height:"12px"}} />
                    <span>Best (Low Scale)</span>
                    <span>&rarr;</span>
                    <img src={"/assets/ic_dislike.svg"} alt={"Worst"} style={{width:"12px", height:"12px"}} />
                    <span>Worst (High Scale)</span>
                </span>
            ),
            value:'green_to_red'
        },
        {
            name:(
                <span style={{display:"inline-flex", alignItems:"center", gap:"4px"}}>
                    <img src={"/assets/ic_dislike.svg"} alt={"Worst"} style={{width:"12px", height:"12px"}} />
                    <span>Worst (Low Scale)</span>
                    <span>&rarr;</span>
                    <img src={"/assets/ic_like.svg"} alt={"Best"} style={{width:"12px", height:"12px"}} />
                    <span>Best (High Scale)</span>
                </span>
            ),
            value:'red_to_green'
        },
    ];

    return <div style={{
        display: "flex",
        flexDirection: "column",
        gap:'20px'
    }}>
        <PersonalizationCardImage src={'/assets/survey_personalization_screens/wellness/wellness_health_intro.png'} alt={'Welcome Screen'} />

        <PersonalizationInput
            title={'Section Title'}
            value={wellnessFormData?.healthSectionTitle?.toUpperCase()}
            setValue={(value) => setWellnessFormData({healthSectionTitle:value?.toUpperCase()})}
            errorMessage={getWellnessError('wellnessSettings', 'healthSectionTitle')}
        />

        <PersonalizationTextarea
            title={'Description'}
            value={wellnessFormData?.healthDescription}
            setValue={(value) => setWellnessFormData({healthDescription:value})}
            errorMessage={getWellnessError('wellnessSettings', 'healthDescription')}
        />

        <PersonalizationInput
            title={'Video Link (Optional)'}
            value={wellnessFormData?.healthVideoLink}
            setValue={(value) => setWellnessFormData({healthVideoLink:value})}
            errorMessage={getWellnessError('wellnessSettings', 'healthVideoLink')}
        />

        <PersonalizationDivider/>


        <Dropdown
            label={"Scale Direction"}
            placeholder={"Scale Direction"}
            type={"scaleDesign"}
            setSelectedOption={(option) => {
                setWellnessFormData({healthMetricScaleDesign:option?.value})
            }}
            selectedOption={wellnessFormData?.healthMetricScaleDesign}
            options={scaleDesignOptions}
        />
    </div>
}
